import type { PropsWithChildren } from 'react';

import { Container } from '~shared/ui/layout';

export const OrdersLayout = ({
  title,
  children,
}: { title: React.ReactNode } & PropsWithChildren) => {
  return (
    <Container>
      <div className="box-border min-h-full w-full pt-10 pb-16">
        {typeof title === 'string' ? (
          <h2 className="mt-0 mb-10 text-4xl font-bold">{title}</h2>
        ) : (
          title
        )}
        <div className="rounded-2xl bg-white p-8">{children}</div>
      </div>
    </Container>
  );
};
